console.log("keyboard-customizer.js loading...");

import { Component } from "@theme/component";
import { KEYBOARD_COLORS, KNOB_COLORS } from "./keyboard-colors.js";

console.log("keyboard-customizer.js: Component imported successfully");

/**
 * Color preset definitions for Corne keyboard (42 keys, 21 per side)
 * Each preset defines default colors and specific key overrides
 */
const CORNE_PRESETS = {
  monochrome: {
    id: "monochrome",
    name: "Monochrome",
    colors: ["#e8e9e4", "#1C1C1C", "#4f4f4fff"],
    keys: {
      L1: "COTTON_WHITE",
      R1: "CHARCOAL_BLACK",
      L2: "CHARCOAL_BLACK",
      R2: "CHARCOAL_BLACK",
      L3: "CHARCOAL_BLACK",
      R3: "CHARCOAL_BLACK",
      L4: "CHARCOAL_BLACK",
      R4: "CHARCOAL_BLACK",
      L5: "CHARCOAL_BLACK",
      R5: "CHARCOAL_BLACK",
      L6: "CHARCOAL_BLACK",
      R6: "COTTON_WHITE",
      L7: "MATTE_GREY",
      R7: "CHARCOAL_BLACK",
      L8: "CHARCOAL_BLACK",
      R8: "CHARCOAL_BLACK",
      L9: "CHARCOAL_BLACK",
      R9: "CHARCOAL_BLACK",
      L10: "CHARCOAL_BLACK",
      R10: "CHARCOAL_BLACK",
      L11: "CHARCOAL_BLACK",
      R11: "CHARCOAL_BLACK",
      L12: "CHARCOAL_BLACK",
      R12: "MATTE_GREY",
      L13: "MATTE_GREY",
      R13: "CHARCOAL_BLACK",
      L14: "CHARCOAL_BLACK",
      R14: "CHARCOAL_BLACK",
      L15: "CHARCOAL_BLACK",
      R15: "CHARCOAL_BLACK",
      L16: "CHARCOAL_BLACK",
      R16: "CHARCOAL_BLACK",
      L17: "CHARCOAL_BLACK",
      R17: "CHARCOAL_BLACK",
      L18: "CHARCOAL_BLACK",
      R18: "MATTE_GREY",
      L19: "MATTE_GREY",
      R19: "COTTON_WHITE",
      L20: "COTTON_WHITE",
      R20: "COTTON_WHITE",
      L21: "COTTON_WHITE",
      R21: "MATTE_GREY",
    },
    topCase: "CHARCOAL_BLACK",
    bottomCase: "CHARCOAL_BLACK",
    leftTopCase: "CHARCOAL_BLACK",
    leftBottomCase: "CHARCOAL_BLACK",
    rightTopCase: "CHARCOAL_BLACK",
    rightBottomCase: "CHARCOAL_BLACK",
    knobColor: null,
  },
  forest: {
    id: "forest",
    name: "Forest Depths",
    colors: ["#e8e9e4", "#A1C1A6", "#758247ff"],
    keys: {
      L1: "COTTON_WHITE",
      R1: "MATTE_LIGHT_GREEN",
      L2: "MATTE_LIGHT_GREEN",
      R2: "MATTE_LIGHT_GREEN",
      L3: "MATTE_LIGHT_GREEN",
      R3: "MATTE_LIGHT_GREEN",
      L4: "MATTE_LIGHT_GREEN",
      R4: "MATTE_LIGHT_GREEN",
      L5: "MATTE_LIGHT_GREEN",
      R5: "MATTE_LIGHT_GREEN",
      L6: "MATTE_LIGHT_GREEN",
      R6: "COTTON_WHITE",
      L7: "MATTE_LIGHT_GREEN",
      R7: "MATTE_LIGHT_GREEN",
      L8: "MATTE_LIGHT_GREEN",
      R8: "MATTE_LIGHT_GREEN",
      L9: "MATTE_LIGHT_GREEN",
      R9: "MATTE_LIGHT_GREEN",
      L10: "MATTE_LIGHT_GREEN",
      R10: "MATTE_LIGHT_GREEN",
      L11: "MATTE_LIGHT_GREEN",
      R11: "MATTE_LIGHT_GREEN",
      L12: "MATTE_LIGHT_GREEN",
      R12: "MATTE_LIGHT_GREEN",
      L13: "MATTE_LIGHT_GREEN",
      R13: "MATTE_LIGHT_GREEN",
      L14: "MATTE_LIGHT_GREEN",
      R14: "MATTE_LIGHT_GREEN",
      L15: "MATTE_LIGHT_GREEN",
      R15: "MATTE_LIGHT_GREEN",
      L16: "MATTE_LIGHT_GREEN",
      R16: "MATTE_LIGHT_GREEN",
      L17: "MATTE_LIGHT_GREEN",
      R17: "MATTE_LIGHT_GREEN",
      L18: "MATTE_LIGHT_GREEN",
      R18: "MATTE_LIGHT_GREEN",
      L19: "MATTE_LIGHT_GREEN",
      R19: "COTTON_WHITE",
      L20: "COTTON_WHITE",
      R20: "COTTON_WHITE",
      L21: "COTTON_WHITE",
      R21: "MATTE_LIGHT_GREEN",
    },
    topCase: "MATTE_ARMY_GREEN",
    bottomCase: "MATTE_ARMY_GREEN",
    leftTopCase: "MATTE_ARMY_GREEN",
    leftBottomCase: "MATTE_ARMY_GREEN",
    rightTopCase: "MATTE_ARMY_GREEN",
    rightBottomCase: "MATTE_ARMY_GREEN",
  },
  amigaWorkbenchOS: {
    id: "amiga-workbench-os",
    name: "Amiga Workbench OS",
    colors: ["#1C1C1C", "#0e5a94ff", "#efa640ff", "#e8e9e4"],
    keys: {
      L1: "CHARCOAL_BLACK",
      R1: "MATTE_BLUE",
      L2: "MATTE_BLUE",
      R2: "MATTE_BLUE",
      L3: "MATTE_BLUE",
      R3: "MATTE_BLUE",
      L4: "MATTE_BLUE",
      R4: "MATTE_BLUE",
      L5: "MATTE_BLUE",
      R5: "MATTE_BLUE",
      L6: "MATTE_BLUE",
      R6: "CHARCOAL_BLACK",
      L7: "MATTE_ORANGE",
      R7: "MATTE_BLUE",
      L8: "MATTE_BLUE",
      R8: "MATTE_ORANGE",
      L9: "MATTE_BLUE",
      R9: "MATTE_BLUE",
      L10: "MATTE_BLUE",
      R10: "MATTE_BLUE",
      L11: "MATTE_ORANGE",
      R11: "MATTE_BLUE",
      L12: "MATTE_BLUE",
      R12: "MATTE_ORANGE",
      L13: "MATTE_ORANGE",
      R13: "MATTE_BLUE",
      L14: "MATTE_BLUE",
      R14: "MATTE_BLUE",
      L15: "MATTE_BLUE",
      R15: "MATTE_BLUE",
      L16: "MATTE_BLUE",
      R16: "MATTE_BLUE",
      L17: "MATTE_BLUE",
      R17: "MATTE_BLUE",
      L18: "MATTE_BLUE",
      R18: "MATTE_ORANGE",
      L19: "CHARCOAL_BLACK",
      R19: "MATTE_ORANGE",
      L20: "MATTE_ORANGE",
      R20: "MATTE_ORANGE",
      L21: "MATTE_ORANGE",
      R21: "CHARCOAL_BLACK",
    },
    topCase: "COTTON_WHITE",
    bottomCase: "COTTON_WHITE",
    leftTopCase: "COTTON_WHITE",
    leftBottomCase: "COTTON_WHITE",
    rightTopCase: "COTTON_WHITE",
    rightBottomCase: "COTTON_WHITE",
    knobColor: null,
  },
  oceanic: {
    id: "oceanic",
    name: "Oceanic",
    colors: ["#628493ff", "#0e5a94ff", "#0f2251ff", "#1a1a1a"],
    keys: {
      L1: "LIGHT_BLUE",
      R1: "MATTE_BLUE",
      L2: "MATTE_BLUE",
      R2: "MATTE_BLUE",
      L3: "MATTE_BLUE",
      R3: "MATTE_BLUE",
      L4: "MATTE_BLUE",
      R4: "MATTE_BLUE",
      L5: "MATTE_BLUE",
      R5: "MATTE_BLUE",
      L6: "MATTE_BLUE",
      R6: "LIGHT_BLUE",
      L7: "MATTE_BLUE",
      R7: "MATTE_BLUE",
      L8: "MATTE_BLUE",
      R8: "MATTE_BLUE",
      L9: "MATTE_BLUE",
      R9: "MATTE_BLUE",
      L10: "MATTE_BLUE",
      R10: "MATTE_BLUE",
      L11: "MATTE_BLUE",
      R11: "MATTE_BLUE",
      L12: "MATTE_BLUE",
      R12: "MATTE_BLUE",
      L13: "MATTE_BLUE",
      R13: "MATTE_BLUE",
      L14: "MATTE_BLUE",
      R14: "MATTE_BLUE",
      L15: "MATTE_BLUE",
      R15: "MATTE_BLUE",
      L16: "MATTE_BLUE",
      R16: "MATTE_BLUE",
      L17: "MATTE_BLUE",
      R17: "MATTE_BLUE",
      L18: "MATTE_BLUE",
      R18: "MATTE_BLUE",
      L19: "MATTE_BLUE",
      R19: "LIGHT_BLUE",
      L20: "LIGHT_BLUE",
      R20: "LIGHT_BLUE",
      L21: "LIGHT_BLUE",
      R21: "MATTE_BLUE",
    },
    topCase: "MATTE_NAVY_BLUE",
    bottomCase: "MATTE_NAVY_BLUE",
    leftTopCase: "MATTE_NAVY_BLUE",
    leftBottomCase: "MATTE_NAVY_BLUE",
    rightTopCase: "MATTE_NAVY_BLUE",
    rightBottomCase: "MATTE_NAVY_BLUE",
  },
  stealth: {
    id: "stealth",
    name: "Stealth",
    colors: ["#4f4f4fff", "#1C1C1C"],
    keys: {
      L1: "MATTE_GREY",
      R1: "CHARCOAL_BLACK",
      L2: "CHARCOAL_BLACK",
      R2: "CHARCOAL_BLACK",
      L3: "CHARCOAL_BLACK",
      R3: "CHARCOAL_BLACK",
      L4: "CHARCOAL_BLACK",
      R4: "CHARCOAL_BLACK",
      L5: "CHARCOAL_BLACK",
      R5: "CHARCOAL_BLACK",
      L6: "CHARCOAL_BLACK",
      R6: "MATTE_GREY",
      L7: "MATTE_GREY",
      R7: "CHARCOAL_BLACK",
      L8: "CHARCOAL_BLACK",
      R8: "CHARCOAL_BLACK",
      L9: "CHARCOAL_BLACK",
      R9: "CHARCOAL_BLACK",
      L10: "CHARCOAL_BLACK",
      R10: "CHARCOAL_BLACK",
      L11: "CHARCOAL_BLACK",
      R11: "CHARCOAL_BLACK",
      L12: "CHARCOAL_BLACK",
      R12: "MATTE_GREY",
      L13: "MATTE_GREY",
      R13: "CHARCOAL_BLACK",
      L14: "CHARCOAL_BLACK",
      R14: "CHARCOAL_BLACK",
      L15: "CHARCOAL_BLACK",
      R15: "CHARCOAL_BLACK",
      L16: "CHARCOAL_BLACK",
      R16: "CHARCOAL_BLACK",
      L17: "CHARCOAL_BLACK",
      R17: "CHARCOAL_BLACK",
      L18: "CHARCOAL_BLACK",
      R18: "MATTE_GREY",
      L19: "MATTE_GREY",
      R19: "MATTE_GREY",
      L20: "MATTE_GREY",
      R20: "MATTE_GREY",
      L21: "MATTE_GREY",
      R21: "MATTE_GREY",
    },
    topCase: "CHARCOAL_BLACK",
    bottomCase: "CHARCOAL_BLACK",
    leftTopCase: "CHARCOAL_BLACK",
    leftBottomCase: "CHARCOAL_BLACK",
    rightTopCase: "CHARCOAL_BLACK",
    rightBottomCase: "CHARCOAL_BLACK",
    knobColor: null,
  },
  custom: {
    id: "custom",
    name: "Custom",
    colors: [],
    keys: {},
    topCase: null,
    bottomCase: null,
    leftTopCase: null,
    leftBottomCase: null,
    rightTopCase: null,
    rightBottomCase: null,
  },
};

/**
 * Color preset definitions for Sofle keyboard (58 keys, 29 per side)
 * Each preset defines default colors and specific key overrides
 * Includes knob color support for encoder knobs
 */
const SOFLE_PRESETS = {
  monochrome: {
    id: "monochrome",
    name: "Monochrome",
    colors: ["#e8e9e4", "#4f4f4fff", "#1C1C1C"],
    keys: {
      L1: "COTTON_WHITE",
      R1: "MATTE_GREY",
      L2: "MATTE_GREY",
      R2: "MATTE_GREY",
      L3: "MATTE_GREY",
      R3: "MATTE_GREY",
      L4: "MATTE_GREY",
      R4: "MATTE_GREY",
      L5: "MATTE_GREY",
      R5: "MATTE_GREY",
      L6: "MATTE_GREY",
      R6: "COTTON_WHITE",
      L7: "MATTE_GREY",
      R7: "CHARCOAL_BLACK",
      L8: "CHARCOAL_BLACK",
      R8: "CHARCOAL_BLACK",
      L9: "CHARCOAL_BLACK",
      R9: "CHARCOAL_BLACK",
      L10: "CHARCOAL_BLACK",
      R10: "CHARCOAL_BLACK",
      L11: "CHARCOAL_BLACK",
      R11: "CHARCOAL_BLACK",
      L12: "CHARCOAL_BLACK",
      R12: "MATTE_GREY",
      L13: "MATTE_GREY",
      R13: "CHARCOAL_BLACK",
      L14: "CHARCOAL_BLACK",
      R14: "CHARCOAL_BLACK",
      L15: "CHARCOAL_BLACK",
      R15: "CHARCOAL_BLACK",
      L16: "CHARCOAL_BLACK",
      R16: "CHARCOAL_BLACK",
      L17: "CHARCOAL_BLACK",
      R17: "CHARCOAL_BLACK",
      L18: "CHARCOAL_BLACK",
      R18: "MATTE_GREY",
      L19: "MATTE_GREY",
      R19: "CHARCOAL_BLACK",
      L20: "CHARCOAL_BLACK",
      R20: "CHARCOAL_BLACK",
      L21: "CHARCOAL_BLACK",
      R21: "CHARCOAL_BLACK",
      L22: "CHARCOAL_BLACK",
      R22: "CHARCOAL_BLACK",
      L23: "CHARCOAL_BLACK",
      R23: "CHARCOAL_BLACK",
      L24: "CHARCOAL_BLACK",
      R24: "MATTE_GREY",
      L25: "CHARCOAL_BLACK",
      R25: "COTTON_WHITE",
      L26: "CHARCOAL_BLACK",
      R26: "COTTON_WHITE",
      L27: "CHARCOAL_BLACK",
      R27: "CHARCOAL_BLACK",
      L28: "COTTON_WHITE",
      R28: "CHARCOAL_BLACK",
      L29: "COTTON_WHITE",
      R29: "CHARCOAL_BLACK",
    },
    topCase: "CHARCOAL_BLACK",
    bottomCase: "CHARCOAL_BLACK",
    leftTopCase: "CHARCOAL_BLACK",
    leftBottomCase: "CHARCOAL_BLACK",
    rightTopCase: "CHARCOAL_BLACK",
    rightBottomCase: "CHARCOAL_BLACK",
    knobColor: "BLK",
  },
  forest: {
    id: "forest",
    name: "Forest Depths",
    colors: ["#e8e9e4", "#A1C1A6", "#758247ff", "#C0C0C0"],
    keys: {
      L1: "COTTON_WHITE",
      R1: "MATTE_LIGHT_GREEN",
      L2: "MATTE_LIGHT_GREEN",
      R2: "MATTE_LIGHT_GREEN",
      L3: "MATTE_LIGHT_GREEN",
      R3: "MATTE_LIGHT_GREEN",
      L4: "MATTE_LIGHT_GREEN",
      R4: "MATTE_LIGHT_GREEN",
      L5: "MATTE_LIGHT_GREEN",
      R5: "MATTE_LIGHT_GREEN",
      L6: "MATTE_LIGHT_GREEN",
      R6: "COTTON_WHITE",
      L7: "MATTE_LIGHT_GREEN",
      R7: "MATTE_LIGHT_GREEN",
      L8: "MATTE_LIGHT_GREEN",
      R8: "MATTE_LIGHT_GREEN",
      L9: "MATTE_LIGHT_GREEN",
      R9: "MATTE_LIGHT_GREEN",
      L10: "MATTE_LIGHT_GREEN",
      R10: "MATTE_LIGHT_GREEN",
      L11: "MATTE_LIGHT_GREEN",
      R11: "MATTE_LIGHT_GREEN",
      L12: "MATTE_LIGHT_GREEN",
      R12: "MATTE_LIGHT_GREEN",
      L13: "MATTE_LIGHT_GREEN",
      R13: "MATTE_LIGHT_GREEN",
      L14: "MATTE_LIGHT_GREEN",
      R14: "MATTE_LIGHT_GREEN",
      L15: "MATTE_LIGHT_GREEN",
      R15: "MATTE_LIGHT_GREEN",
      L16: "MATTE_LIGHT_GREEN",
      R16: "MATTE_LIGHT_GREEN",
      L17: "MATTE_LIGHT_GREEN",
      R17: "MATTE_LIGHT_GREEN",
      L18: "MATTE_LIGHT_GREEN",
      R18: "MATTE_LIGHT_GREEN",
      L19: "MATTE_LIGHT_GREEN",
      R19: "MATTE_LIGHT_GREEN",
      L20: "MATTE_LIGHT_GREEN",
      R20: "MATTE_LIGHT_GREEN",
      L21: "MATTE_LIGHT_GREEN",
      R21: "MATTE_LIGHT_GREEN",
      L22: "MATTE_LIGHT_GREEN",
      R22: "MATTE_LIGHT_GREEN",
      L23: "MATTE_LIGHT_GREEN",
      R23: "MATTE_LIGHT_GREEN",
      L24: "MATTE_LIGHT_GREEN",
      R24: "MATTE_LIGHT_GREEN",
      L25: "MATTE_LIGHT_GREEN",
      R25: "COTTON_WHITE",
      L26: "MATTE_LIGHT_GREEN",
      R26: "COTTON_WHITE",
      L27: "MATTE_LIGHT_GREEN",
      R27: "MATTE_LIGHT_GREEN",
      L28: "COTTON_WHITE",
      R28: "MATTE_LIGHT_GREEN",
      L29: "COTTON_WHITE",
      R29: "MATTE_LIGHT_GREEN",
    },
    topCase: "MATTE_ARMY_GREEN",
    bottomCase: "MATTE_ARMY_GREEN",
    leftTopCase: "MATTE_ARMY_GREEN",
    leftBottomCase: "MATTE_ARMY_GREEN",
    rightTopCase: "MATTE_ARMY_GREEN",
    rightBottomCase: "MATTE_ARMY_GREEN",
    knobColor: "SLV",
  },
  sunset: {
    id: "amiga-workbench-os",
    name: "Amiga Workbench OS",
    colors: ["#1C1C1C", "#0e5a94ff", "#efa640ff", "#e8e9e4"],
    keys: {
      L1: "CHARCOAL_BLACK",
      R1: "MATTE_BLUE",
      L2: "MATTE_ORANGE",
      R2: "MATTE_BLUE",
      L3: "MATTE_ORANGE",
      R3: "MATTE_BLUE",
      L4: "MATTE_ORANGE",
      R4: "MATTE_BLUE",
      L5: "MATTE_ORANGE",
      R5: "MATTE_BLUE",
      L6: "MATTE_ORANGE",
      R6: "CHARCOAL_BLACK",
      L7: "MATTE_ORANGE",
      R7: "MATTE_BLUE",
      L8: "MATTE_BLUE",
      R8: "MATTE_BLUE",
      L9: "MATTE_BLUE",
      R9: "MATTE_BLUE",
      L10: "MATTE_BLUE",
      R10: "MATTE_BLUE",
      L11: "MATTE_BLUE",
      R11: "MATTE_BLUE",
      L12: "MATTE_BLUE",
      R12: "MATTE_ORANGE",
      L13: "MATTE_ORANGE",
      R13: "MATTE_BLUE",
      L14: "MATTE_BLUE",
      R14: "MATTE_ORANGE",
      L15: "MATTE_BLUE",
      R15: "MATTE_BLUE",
      L16: "MATTE_BLUE",
      R16: "MATTE_BLUE",
      L17: "MATTE_ORANGE",
      R17: "MATTE_BLUE",
      L18: "MATTE_BLUE",
      R18: "MATTE_ORANGE",
      L19: "MATTE_ORANGE",
      R19: "MATTE_BLUE",
      L20: "MATTE_BLUE",
      R20: "MATTE_BLUE",
      L21: "MATTE_BLUE",
      R21: "MATTE_BLUE",
      L22: "MATTE_BLUE",
      R22: "MATTE_BLUE",
      L23: "MATTE_BLUE",
      R23: "MATTE_BLUE",
      L24: "MATTE_BLUE",
      R24: "MATTE_ORANGE",
      L25: "CHARCOAL_BLACK",
      R25: "MATTE_ORANGE",
      L26: "CHARCOAL_BLACK",
      R26: "MATTE_ORANGE",
      L27: "CHARCOAL_BLACK",
      R27: "CHARCOAL_BLACK",
      L28: "MATTE_ORANGE",
      R28: "CHARCOAL_BLACK",
      L29: "MATTE_ORANGE",
      R29: "CHARCOAL_BLACK",
    },
    topCase: "COTTON_WHITE",
    bottomCase: "COTTON_WHITE",
    leftTopCase: "COTTON_WHITE",
    leftBottomCase: "COTTON_WHITE",
    rightTopCase: "COTTON_WHITE",
    rightBottomCase: "COTTON_WHITE",
    knobColor: "CHARCOAL_BLACK",
  },
  oceanic: {
    id: "oceanic",
    name: "Oceanic",
    colors: ["#628493ff", "#0e5a94ff", "#0f2251ff", "#1a1a1a"],
    keys: {
      L1: "LIGHT_BLUE",
      R1: "MATTE_BLUE",
      L2: "MATTE_BLUE",
      R2: "MATTE_BLUE",
      L3: "MATTE_BLUE",
      R3: "MATTE_BLUE",
      L4: "MATTE_BLUE",
      R4: "MATTE_BLUE",
      L5: "MATTE_BLUE",
      R5: "MATTE_BLUE",
      L6: "MATTE_BLUE",
      R6: "LIGHT_BLUE",
      L7: "MATTE_BLUE",
      R7: "MATTE_BLUE",
      L8: "MATTE_BLUE",
      R8: "MATTE_BLUE",
      L9: "MATTE_BLUE",
      R9: "MATTE_BLUE",
      L10: "MATTE_BLUE",
      R10: "MATTE_BLUE",
      L11: "MATTE_BLUE",
      R11: "MATTE_BLUE",
      L12: "MATTE_BLUE",
      R12: "MATTE_BLUE",
      L13: "MATTE_BLUE",
      R13: "MATTE_BLUE",
      L14: "MATTE_BLUE",
      R14: "MATTE_BLUE",
      L15: "MATTE_BLUE",
      R15: "MATTE_BLUE",
      L16: "MATTE_BLUE",
      R16: "MATTE_BLUE",
      L17: "MATTE_BLUE",
      R17: "MATTE_BLUE",
      L18: "MATTE_BLUE",
      R18: "MATTE_BLUE",
      L19: "MATTE_BLUE",
      R19: "MATTE_BLUE",
      L20: "MATTE_BLUE",
      R20: "MATTE_BLUE",
      L21: "MATTE_BLUE",
      R21: "MATTE_BLUE",
      L22: "MATTE_BLUE",
      R22: "MATTE_BLUE",
      L23: "MATTE_BLUE",
      R23: "MATTE_BLUE",
      L24: "MATTE_BLUE",
      R24: "MATTE_BLUE",
      L25: "MATTE_BLUE",
      R25: "LIGHT_BLUE",
      L26: "MATTE_BLUE",
      R26: "LIGHT_BLUE",
      L27: "LIGHT_BLUE",
      R27: "LIGHT_BLUE",
      L28: "LIGHT_BLUE",
      R28: "MATTE_BLUE",
      L29: "LIGHT_BLUE",
      R29: "MATTE_BLUE",
    },
    topCase: "MATTE_NAVY_BLUE",
    bottomCase: "MATTE_NAVY_BLUE",
    leftTopCase: "MATTE_NAVY_BLUE",
    leftBottomCase: "MATTE_NAVY_BLUE",
    rightTopCase: "MATTE_NAVY_BLUE",
    rightBottomCase: "MATTE_NAVY_BLUE",
    knobColor: "BLK",
  },
  stealth: {
    id: "stealth",
    name: "Stealth",
    colors: ["#4f4f4fff", "#1C1C1C"],
    keys: {
      L1: "MATTE_GREY",
      R1: "MATTE_GREY",
      L2: "MATTE_GREY",
      R2: "MATTE_GREY",
      L3: "MATTE_GREY",
      R3: "MATTE_GREY",
      L4: "MATTE_GREY",
      R4: "MATTE_GREY",
      L5: "MATTE_GREY",
      R5: "MATTE_GREY",
      L6: "MATTE_GREY",
      R6: "MATTE_GREY",
      L7: "CHARCOAL_BLACK",
      R7: "CHARCOAL_BLACK",
      L8: "CHARCOAL_BLACK",
      R8: "CHARCOAL_BLACK",
      L9: "CHARCOAL_BLACK",
      R9: "CHARCOAL_BLACK",
      L10: "CHARCOAL_BLACK",
      R10: "CHARCOAL_BLACK",
      L11: "CHARCOAL_BLACK",
      R11: "CHARCOAL_BLACK",
      L12: "CHARCOAL_BLACK",
      R12: "CHARCOAL_BLACK",
      L13: "CHARCOAL_BLACK",
      R13: "CHARCOAL_BLACK",
      L14: "CHARCOAL_BLACK",
      R14: "MATTE_GREY",
      L15: "CHARCOAL_BLACK",
      R15: "CHARCOAL_BLACK",
      L16: "CHARCOAL_BLACK",
      R16: "CHARCOAL_BLACK",
      L17: "MATTE_GREY",
      R17: "CHARCOAL_BLACK",
      L18: "CHARCOAL_BLACK",
      R18: "CHARCOAL_BLACK",
      L19: "CHARCOAL_BLACK",
      R19: "CHARCOAL_BLACK",
      L20: "CHARCOAL_BLACK",
      R20: "CHARCOAL_BLACK",
      L21: "CHARCOAL_BLACK",
      R21: "CHARCOAL_BLACK",
      L22: "CHARCOAL_BLACK",
      R22: "CHARCOAL_BLACK",
      L23: "CHARCOAL_BLACK",
      R23: "CHARCOAL_BLACK",
      L24: "CHARCOAL_BLACK",
      R24: "CHARCOAL_BLACK",
      L25: "CHARCOAL_BLACK",
      R25: "MATTE_GREY",
      L26: "CHARCOAL_BLACK",
      R26: "MATTE_GREY",
      L27: "CHARCOAL_BLACK",
      R27: "CHARCOAL_BLACK",
      L28: "MATTE_GREY",
      R28: "CHARCOAL_BLACK",
      L29: "MATTE_GREY",
      R29: "CHARCOAL_BLACK",
    },
    topCase: "CHARCOAL_BLACK",
    bottomCase: "CHARCOAL_BLACK",
    leftTopCase: "CHARCOAL_BLACK",
    leftBottomCase: "CHARCOAL_BLACK",
    rightTopCase: "CHARCOAL_BLACK",
    rightBottomCase: "CHARCOAL_BLACK",
    knobColor: "BLK",
  },
  custom: {
    id: "custom",
    name: "Custom",
    colors: [],
    keys: {},
    topCase: null,
    bottomCase: null,
    leftTopCase: null,
    leftBottomCase: null,
    rightTopCase: null,
    rightBottomCase: null,
    knobColor: null,
  },
};

/**
 * Keyboard configuration definitions
 * Defines layout-specific properties for different keyboard types
 */
const KEYBOARD_CONFIGS = {
  corne: {
    id: "corne",
    name: "Corne",
    keyCount: 42,
    keysPerSide: 21,
    hasKnobs: false,
    mirrorMap: {
      // Row 1: L1-L6 ↔ R6-R1
      L1: "R6",
      L2: "R5",
      L3: "R4",
      L4: "R3",
      L5: "R2",
      L6: "R1",
      // Row 2: L7-L12 ↔ R12-R7
      L7: "R12",
      L8: "R11",
      L9: "R10",
      L10: "R9",
      L11: "R8",
      L12: "R7",
      // Row 3: L13-L18 ↔ R18-R13
      L13: "R18",
      L14: "R17",
      L15: "R16",
      L16: "R15",
      L17: "R14",
      L18: "R13",
      // Thumb cluster: L19-L21 ↔ R21-R19
      L19: "R21",
      L20: "R20",
      L21: "R19",
    },
  },

  sofle: {
    id: "sofle",
    name: "Sofle",
    keyCount: 58,
    keysPerSide: 29,
    hasKnobs: true,
    knobElements: ["left", "right"],
    mirrorMap: {
      // Row 1 (6 keys): L1-L6 ↔ R6-R1
      L1: "R6",
      L2: "R5",
      L3: "R4",
      L4: "R3",
      L5: "R2",
      L6: "R1",
      // Row 2 (6 keys): L7-L12 ↔ R12-R7
      L7: "R12",
      L8: "R11",
      L9: "R10",
      L10: "R9",
      L11: "R8",
      L12: "R7",
      // Row 3 (6 keys): L13-L18 ↔ R18-R13
      L13: "R18",
      L14: "R17",
      L15: "R16",
      L16: "R15",
      L17: "R14",
      L18: "R13",
      // Row 4 (6 keys): L19-L24 ↔ R24-R19
      L19: "R24",
      L20: "R23",
      L21: "R22",
      L22: "R21",
      L23: "R20",
      L24: "R19",
      // Thumb cluster (5 keys): L25-L29 ↔ R29-R25
      L25: "R29",
      L26: "R28",
      L27: "R27",
      L28: "R26",
      L29: "R25",
    },
  },
};

/**
 * Keyboard Customizer Component
 * Main component for keyboard color customization block instances
 * Extends Component base class to use theme patterns (refs, declarative events)
 */
export class KeyboardCustomizerComponent extends Component {
  // Private state properties
  #keyColors = {}; // { L1: 'BLK', L2: 'WHT', ... }
  #leftTopCaseColor = null; // 'BLK'
  #leftBottomCaseColor = null; // 'BLK'
  #rightTopCaseColor = null; // 'BLK'
  #rightBottomCaseColor = null; // 'BLK'
  #knobColor = null; // 'BLK' - for Sofle encoder knobs
  #currentPreset = "custom"; // 'monochrome', 'forest', etc.
  #keyboardType = "corne"; // 'corne' or 'sofle'
  #keyboardConfig = null; // Reference to KEYBOARD_CONFIGS[keyboardType]

  /**
   * Get the appropriate preset collection for the current keyboard type
   * @returns {Object} CORNE_PRESETS or SOFLE_PRESETS
   */
  #getPresets() {
    return this.#keyboardType === "sofle" ? SOFLE_PRESETS : CORNE_PRESETS;
  }

  connectedCallback() {
    super.connectedCallback();

    console.log(
      "KeyboardCustomizerComponent connected",
      this.dataset.componentId
    );

    // Initialize state from dataset or defaults
    this.#initializeState();

    // Generate preset buttons from PRESETS object
    this.#generatePresetButtons();

    // Setup preset buttons
    this.#setupPresetButtons();

    // TEMPORARY: Add direct event listener as fallback
    const button = this.querySelector(".kb-painter__customize-btn");
    if (button) {
      console.log("Found button, adding direct listener");
      button.addEventListener("click", (e) => {
        console.log("Button clicked via direct listener");
        this.openCustomizer();
      });
    } else {
      console.error("Button not found in component");
    }

    // Listen for apply events from dialog
    document.addEventListener(
      KeyboardCustomizerApplyEvent.eventName,
      this.#handleApply
    );
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(
      KeyboardCustomizerApplyEvent.eventName,
      this.#handleApply
    );
  }

  /**
   * Opens the customizer dialog
   * Called via declarative event: on:click="/openCustomizer"
   */
  openCustomizer() {
    console.log("openCustomizer called");
    const dialog = document.querySelector("keyboard-customizer-dialog");
    console.log("Found dialog:", dialog);
    if (!dialog) {
      console.error(
        "Keyboard customizer dialog not found. Make sure it is rendered in the layout."
      );
      return;
    }

    const mainColors = this.#getMainColors();
    const knobColors = this.#getKnobColors();
    console.log("Color data:", mainColors);

    // Use stored custom preset if available, otherwise use current state
    let keyColorsToUse = this.#keyColors;
    let leftTopCaseToUse = this.#leftTopCaseColor;
    let leftBottomCaseToUse = this.#leftBottomCaseColor;
    let rightTopCaseToUse = this.#rightTopCaseColor;
    let rightBottomCaseToUse = this.#rightBottomCaseColor;
    let knobColorToUse = this.#knobColor;

    // Check if we have a stored custom preset with actual colors
    const presets = this.#getPresets();
    if (
      presets.custom.colors &&
      presets.custom.colors.length > 0 &&
      presets.custom.keys &&
      Object.keys(presets.custom.keys).length > 0
    ) {
      console.log("Loading stored custom preset:", presets.custom);
      keyColorsToUse = presets.custom.keys;
      leftTopCaseToUse = presets.custom.leftTopCase || presets.custom.topCase;
      leftBottomCaseToUse =
        presets.custom.leftBottomCase || presets.custom.bottomCase;
      rightTopCaseToUse = presets.custom.rightTopCase || presets.custom.topCase;
      rightBottomCaseToUse =
        presets.custom.rightBottomCase || presets.custom.bottomCase;
      knobColorToUse = presets.custom.knobColor || this.#knobColor;
    } else {
      console.log("Using current state, no stored custom preset found");
    }

    // Pass current state to dialog
    dialog.open(
      this.dataset.componentId,
      mainColors,
      knobColors,
      keyColorsToUse,
      {
        leftTopCaseColor: leftTopCaseToUse,
        leftBottomCaseColor: leftBottomCaseToUse,
        rightTopCaseColor: rightTopCaseToUse,
        rightBottomCaseColor: rightBottomCaseToUse,
        topCaseColor: leftTopCaseToUse, // Backward compatibility
        bottomCaseColor: leftBottomCaseToUse, // Backward compatibility
        knobColor: knobColorToUse, // For Sofle keyboards
        keyboardType: this.#keyboardType,
        defaultKeyCode: this.dataset.defaultKeyCode,
        defaultTopCode: this.dataset.defaultTopCode,
        defaultBottomCode: this.dataset.defaultBottomCode,
      }
    );
  }

  /**
   * Initialize state from dataset or defaults
   */
  #initializeState() {
    // Get keyboard type from data attribute
    this.#keyboardType = this.dataset.keyboardType || "corne";
    this.#keyboardConfig = KEYBOARD_CONFIGS[this.#keyboardType];

    if (!this.#keyboardConfig) {
      console.error(
        `Unknown keyboard type: ${this.#keyboardType}, falling back to corne`
      );
      this.#keyboardType = "corne";
      this.#keyboardConfig = KEYBOARD_CONFIGS.corne;
    }

    console.log(
      `Keyboard customizer initialized: ${this.#keyboardType}`,
      this.#keyboardConfig
    );

    // Load custom preset from localStorage first
    const wasInitialized = this.#loadCustomPresetFromStorage();

    // Load key colors from dataset or empty
    this.#keyColors = this.#getCurrentKeyColors();

    // Load case colors from dataset or defaults (with backward compatibility)
    this.#leftTopCaseColor =
      this.dataset.leftTopCaseColor ||
      this.dataset.topCaseColor ||
      this.dataset.defaultTopCode ||
      null;
    this.#leftBottomCaseColor =
      this.dataset.leftBottomCaseColor ||
      this.dataset.bottomCaseColor ||
      this.dataset.defaultBottomCode ||
      null;
    this.#rightTopCaseColor =
      this.dataset.rightTopCaseColor ||
      this.dataset.topCaseColor ||
      this.dataset.defaultTopCode ||
      null;
    this.#rightBottomCaseColor =
      this.dataset.rightBottomCaseColor ||
      this.dataset.bottomCaseColor ||
      this.dataset.defaultBottomCode ||
      null;

    // Determine current preset (default to custom)
    this.#currentPreset = "custom";

    // If we initialized defaults and component state is empty, apply the custom preset
    if (wasInitialized && Object.keys(this.#keyColors).length === 0) {
      console.log("Applying initialized custom preset to component state");
      this.#applyPreset("custom");
    } else {
      // Update UI to match initial state
      this.#updatePresetButtons();
    }
  }

  /**
   * Generate preset buttons dynamically from PRESETS object
   * This ensures the UI matches the JavaScript preset definitions
   */
  #generatePresetButtons() {
    const container = this.querySelector("[data-default-presets]");
    if (!container) {
      console.error("Preset container not found");
      return;
    }

    // Clear any existing content
    container.innerHTML = "";

    // Generate buttons for all presets except 'custom'
    const presets = this.#getPresets();
    Object.entries(presets).forEach(([presetId, preset]) => {
      if (presetId === "custom") return; // Skip custom, we'll add it at the end

      // Only render presets with valid color data
      if (!preset.colors || preset.colors.length === 0) {
        console.warn(`Skipping preset ${presetId}: no colors defined`);
        return;
      }

      const button = this.#createPresetButton(presetId, preset);
      container.appendChild(button);
    });

    // Add custom preset button at the end with special styling
    const customButton = this.#createCustomPresetButton();
    container.appendChild(customButton);
  }

  /**
   * Create a preset button element
   */
  #createPresetButton(presetId, preset) {
    const button = document.createElement("button");
    button.type = "button";
    button.className = "kb-painter__preset";
    button.dataset.preset = presetId;

    // Create preset name
    const nameDiv = document.createElement("div");
    nameDiv.className = "kb-painter__preset-name";
    nameDiv.textContent = preset.name;

    // Create color strip
    const stripDiv = document.createElement("div");
    stripDiv.className = "kb-painter__preset-strip";

    // Add color swatches
    if (preset.colors && preset.colors.length > 0) {
      preset.colors.forEach((hexColor) => {
        const colorDiv = document.createElement("div");
        colorDiv.className = "kb-painter__preset-color";
        colorDiv.style.background = hexColor;
        stripDiv.appendChild(colorDiv);
      });
    }

    button.appendChild(nameDiv);
    button.appendChild(stripDiv);

    return button;
  }

  /**
   * Create the custom preset button with gradient background
   * Always shows the same gradient visual (doesn't change with saved colors)
   */
  #createCustomPresetButton() {
    const button = document.createElement("button");
    button.type = "button";
    button.className = "kb-painter__preset is-active";
    button.dataset.preset = "custom";

    const nameDiv = document.createElement("div");
    nameDiv.className = "kb-painter__preset-name";
    nameDiv.textContent = "Custom";

    const stripDiv = document.createElement("div");
    stripDiv.className = "kb-painter__preset-strip";

    // Always show gradient for custom preset button
    const colorDiv = document.createElement("div");
    colorDiv.className = "kb-painter__preset-color";
    colorDiv.style.background =
      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)";
    stripDiv.appendChild(colorDiv);

    button.appendChild(nameDiv);
    button.appendChild(stripDiv);

    return button;
  }

  /**
   * Setup preset button click handlers
   */
  #setupPresetButtons() {
    const buttons = this.querySelectorAll("[data-preset]");
    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        const presetId = button.dataset.preset;
        this.#applyPreset(presetId);
      });
    });
  }

  /**
   * Apply a preset color scheme
   */
  #applyPreset(presetId) {
    const presets = this.#getPresets();
    const preset = presets[presetId];
    if (!preset) {
      console.error(`Preset not found: ${presetId}`);
      return;
    }

    console.log(`Applying preset: ${presetId} to ${this.#keyboardType}`);

    // Special handling for custom preset - restore saved customization
    if (presetId === "custom") {
      // Check if we have valid saved custom data
      if (preset.keys && Object.keys(preset.keys).length > 0) {
        // Filter out null values and use only defined colors
        this.#keyColors = {};
        Object.entries(preset.keys).forEach(([keyId, colorCode]) => {
          if (
            keyId !== "default" &&
            colorCode !== null &&
            colorCode !== undefined
          ) {
            this.#keyColors[keyId] = colorCode;
          }
        });

        // Restore case colors (with fallback to defaults if not set)
        this.#leftTopCaseColor =
          preset.leftTopCase || preset.topCase || this.dataset.defaultTopCode;
        this.#leftBottomCaseColor =
          preset.leftBottomCase ||
          preset.bottomCase ||
          this.dataset.defaultBottomCode;
        this.#rightTopCaseColor =
          preset.rightTopCase || preset.topCase || this.dataset.defaultTopCode;
        this.#rightBottomCaseColor =
          preset.rightBottomCase ||
          preset.bottomCase ||
          this.dataset.defaultBottomCode;

        // Restore knob color if applicable
        if (this.#keyboardConfig.hasKnobs) {
          this.#knobColor = preset.knobColor || KNOB_COLORS[0]?.code || "";
        }
      } else {
        console.warn("No saved custom preset data found");
      }

      this.#currentPreset = "custom";
      this.#updateBlockPreview();
      this.#updateHiddenInputs();
      this.#updatePresetButtons();
      return;
    }

    // Standard preset handling for non-custom presets
    // Build full key color map from preset
    this.#keyColors = {};
    const defaultColor = preset.keys.default;

    // Apply default to all keys based on keyboard config
    if (defaultColor) {
      for (let i = 1; i <= this.#keyboardConfig.keysPerSide; i++) {
        this.#keyColors[`L${i}`] = defaultColor;
        this.#keyColors[`R${i}`] = defaultColor;
      }
    }

    // Apply specific key overrides (if they exist for this keyboard)
    Object.entries(preset.keys).forEach(([keyId, colorCode]) => {
      if (keyId !== "default" && colorCode) {
        this.#keyColors[keyId] = colorCode;
      }
    });

    // Set case colors (use same preset colors for both sides)
    this.#leftTopCaseColor = preset.leftTopCase || preset.topCase;
    this.#leftBottomCaseColor = preset.leftBottomCase || preset.bottomCase;
    this.#rightTopCaseColor = preset.rightTopCase || preset.topCase;
    this.#rightBottomCaseColor = preset.rightBottomCase || preset.bottomCase;

    // Set knob color if keyboard has knobs
    if (this.#keyboardConfig.hasKnobs) {
      // Use preset's knobColor if available, otherwise default to first knob color
      this.#knobColor = preset.knobColor || KNOB_COLORS[0]?.code || "";
    }

    this.#currentPreset = presetId;

    // Update UI
    this.#updateBlockPreview();
    this.#updateHiddenInputs();
    this.#updatePresetButtons();
  }

  /**
   * Update preset button active states
   * Note: Custom button keeps its gradient visual and doesn't update
   */
  #updatePresetButtons() {
    const buttons = this.querySelectorAll("[data-preset]");
    buttons.forEach((button) => {
      if (button.dataset.preset === this.#currentPreset) {
        button.classList.add("is-active");
      } else {
        button.classList.remove("is-active");
      }
    });
  }

  /**
   * Update hidden form inputs with current state
   * Stores preset name for customers and complete config for admin
   */
  #updateHiddenInputs() {
    // 1. Preset name (friendly name for customer display)
    const presetInput = this.querySelector('[data-input="preset-name"]');
    if (presetInput) {
      const presets = this.#getPresets();
      const currentPreset = presets[this.#currentPreset];
      presetInput.value = currentPreset?.name || "Custom";
    }

    // 2. Complete configuration object (hidden from customers, visible in admin)
    const configInput = this.querySelector('[data-input="color-config"]');
    if (configInput) {
      // Build complete configuration with friendly names
      const config = {
        preset: this.#currentPreset,
        presetName: presetInput?.value || "Custom",
        keys: {},
        cases: {
          leftTop: null,
          leftBottom: null,
          rightTop: null,
          rightBottom: null
        }
      };

      // Convert all key colors to friendly names
      Object.entries(this.#keyColors).forEach(([keyId, colorCode]) => {
        const color = this.#findColorByCode(colorCode);
        config.keys[keyId] = color ? color.name : colorCode;
      });

      // Convert case colors to friendly names
      const leftTopColor = this.#findColorByCode(this.#leftTopCaseColor);
      const leftBottomColor = this.#findColorByCode(this.#leftBottomCaseColor);
      const rightTopColor = this.#findColorByCode(this.#rightTopCaseColor);
      const rightBottomColor = this.#findColorByCode(this.#rightBottomCaseColor);

      config.cases.leftTop = leftTopColor ? leftTopColor.name : "";
      config.cases.leftBottom = leftBottomColor ? leftBottomColor.name : "";
      config.cases.rightTop = rightTopColor ? rightTopColor.name : "";
      config.cases.rightBottom = rightBottomColor ? rightBottomColor.name : "";

      // Add knob color for Sofle keyboards
      if (this.#keyboardConfig.hasKnobs && this.#knobColor) {
        const knobColor = this.#findColorByCode(this.#knobColor);
        config.knob = knobColor ? knobColor.name : "";
      }

      // Store as formatted JSON (readable in admin)
      configInput.value = JSON.stringify(config, null, 2);
    }
  }

  /**
   * Get main keyboard colors (for keys and cases)
   */
  #getMainColors() {
    return KEYBOARD_COLORS;
  }

  /**
   * Get knob colors (for Sofle encoder knobs)
   */
  #getKnobColors() {
    return KNOB_COLORS;
  }

  /**
   * Find color object by code from either palette
   */
  #findColorByCode(colorCode) {
    if (!colorCode) return null;

    // Search main colors first
    let color = KEYBOARD_COLORS.find((c) => c.code === colorCode);

    // If not found, search knob colors
    if (!color) {
      color = KNOB_COLORS.find((c) => c.code === colorCode);
    }

    return color;
  }

  /**
   * Handle apply event from dialog
   */
  #handleApply = (event) => {
    // Only handle events for this component
    if (event.detail.componentId !== this.dataset.componentId) return;

    // Update state from dialog
    this.#keyColors = { ...event.detail.keyColors };
    this.#leftTopCaseColor = event.detail.leftTopCase;
    this.#leftBottomCaseColor = event.detail.leftBottomCase;
    this.#rightTopCaseColor = event.detail.rightTopCase;
    this.#rightBottomCaseColor = event.detail.rightBottomCase;

    // Update knob color if keyboard has knobs
    if (this.#keyboardConfig.hasKnobs && event.detail.knobColor) {
      this.#knobColor = event.detail.knobColor;
    }

    this.#currentPreset = "custom"; // Always switch to custom on manual edit

    // Store color scheme in PRESETS.custom
    this.#updateCustomPreset(event.detail);

    // Update UI
    this.#updateBlockPreview();
    this.#updateHiddenInputs();
    this.#updatePresetButtons();
  };

  /**
   * Get current key colors from dataset
   */
  #getCurrentKeyColors() {
    try {
      return JSON.parse(this.dataset.keyColors || "{}");
    } catch (e) {
      console.error("Failed to parse keyColors:", e);
      return {};
    }
  }

  /**
   * Get settings from dataset
   */
  #getSettings() {
    return {
      defaultKeyCode: this.dataset.defaultKeyCode || "",
      defaultTopCode: this.dataset.defaultTopCode || "",
      defaultBottomCode: this.dataset.defaultBottomCode || "",
    };
  }

  /**
   * Save custom preset to localStorage for cross-session persistence
   */
  #saveCustomPresetToStorage() {
    try {
      const presets = this.#getPresets();
      const customData = {
        colors: presets.custom.colors,
        keys: presets.custom.keys,
        topCase: presets.custom.topCase,
        bottomCase: presets.custom.bottomCase,
        leftTopCase: presets.custom.leftTopCase,
        leftBottomCase: presets.custom.leftBottomCase,
        rightTopCase: presets.custom.rightTopCase,
        rightBottomCase: presets.custom.rightBottomCase,
        knobColor: presets.custom.knobColor,
        timestamp: Date.now(),
      };
      // Use keyboard-specific localStorage key
      const storageKey = `keyboard-custom-preset-${this.#keyboardType}`;
      localStorage.setItem(storageKey, JSON.stringify(customData));
    } catch (error) {
      console.warn("Failed to save custom preset to localStorage:", error);
    }
  }

  /**
   * Load custom preset from localStorage
   */
  #loadCustomPresetFromStorage() {
    try {
      // Use keyboard-specific localStorage key
      const storageKey = `keyboard-custom-preset-${this.#keyboardType}`;
      const stored = localStorage.getItem(storageKey);
      if (stored) {
        const customData = JSON.parse(stored);
        const presets = this.#getPresets();
        presets.custom.colors = customData.colors || [];
        presets.custom.keys = customData.keys || {};
        // Backward compatibility: use old topCase/bottomCase if new properties don't exist
        presets.custom.topCase = customData.topCase || null;
        presets.custom.bottomCase = customData.bottomCase || null;
        presets.custom.leftTopCase =
          customData.leftTopCase || customData.topCase || null;
        presets.custom.leftBottomCase =
          customData.leftBottomCase || customData.bottomCase || null;
        presets.custom.rightTopCase =
          customData.rightTopCase || customData.topCase || null;
        presets.custom.rightBottomCase =
          customData.rightBottomCase || customData.bottomCase || null;
        presets.custom.knobColor = customData.knobColor || null;
        console.log("Loaded custom preset from localStorage");
        return true;
      }
    } catch (error) {
      console.warn("Failed to load custom preset from localStorage:", error);
    }

    // No saved preset found, initialize with defaults
    console.log("No saved custom preset found, initializing with defaults");
    return this.#initializeDefaultCustomPreset();
  }

  /**
   * Initialize custom preset with default values from first color in swatch
   * Called when no saved custom preset exists in localStorage
   * @private
   */
  #initializeDefaultCustomPreset() {
    const colorData = this.#getMainColors();

    // Edge case: No color data available
    if (!colorData || colorData.length === 0) {
      console.warn("No color data available for initializing custom preset");
      return false;
    }

    // Get first color programmatically
    const firstColor = colorData[0];
    const firstColorCode = firstColor.code;
    const firstColorHex = firstColor.hex;

    const presets = this.#getPresets();

    // Initialize colors array with first color's hex
    presets.custom.colors = [firstColorHex];

    // Initialize all keys with first color code (based on keyboard config)
    presets.custom.keys = {};
    for (let i = 1; i <= this.#keyboardConfig.keysPerSide; i++) {
      presets.custom.keys[`L${i}`] = firstColorCode;
      presets.custom.keys[`R${i}`] = firstColorCode;
    }

    // Initialize case colors with first color code
    presets.custom.topCase = firstColorCode;
    presets.custom.bottomCase = firstColorCode;
    presets.custom.leftTopCase = firstColorCode;
    presets.custom.leftBottomCase = firstColorCode;
    presets.custom.rightTopCase = firstColorCode;
    presets.custom.rightBottomCase = firstColorCode;

    console.log(
      `Initialized ${this.#keyboardType} custom preset with default values:`,
      presets.custom
    );
    return true;
  }

  /**
   * Update custom preset with received color scheme
   */
  #updateCustomPreset(eventDetail) {
    const colorData = this.#getMainColors();
    if (!colorData || colorData.length === 0) {
      console.warn("No color data available, cannot update custom preset");
      return;
    }

    // Extract unique colors from keys and cases
    const usedColorCodes = new Set();
    Object.values(eventDetail.keyColors).forEach((colorCode) => {
      if (colorCode) usedColorCodes.add(colorCode);
    });

    if (eventDetail.leftTopCase) usedColorCodes.add(eventDetail.leftTopCase);
    if (eventDetail.leftBottomCase)
      usedColorCodes.add(eventDetail.leftBottomCase);
    if (eventDetail.rightTopCase) usedColorCodes.add(eventDetail.rightTopCase);
    if (eventDetail.rightBottomCase)
      usedColorCodes.add(eventDetail.rightBottomCase);
    if (eventDetail.knobColor) usedColorCodes.add(eventDetail.knobColor);

    // Convert color codes to hex values (matching other presets format)
    const usedColors = Array.from(usedColorCodes)
      .map((code) => this.#findColorByCode(code))
      .filter((color) => color && color.hex)
      .map((color) => color.hex);

    const presets = this.#getPresets();

    // Update custom preset structure
    presets.custom.colors = usedColors;
    presets.custom.keys = { ...eventDetail.keyColors };
    presets.custom.topCase = eventDetail.leftTopCase; // Backward compatibility
    presets.custom.bottomCase = eventDetail.leftBottomCase; // Backward compatibility
    presets.custom.leftTopCase = eventDetail.leftTopCase;
    presets.custom.leftBottomCase = eventDetail.leftBottomCase;
    presets.custom.rightTopCase = eventDetail.rightTopCase;
    presets.custom.rightBottomCase = eventDetail.rightBottomCase;

    // Add knob color if present
    if (eventDetail.knobColor) {
      presets.custom.knobColor = eventDetail.knobColor;
    }

    // Save to localStorage for cross-session persistence
    this.#saveCustomPresetToStorage();

    console.log(`Updated ${this.#keyboardType} custom preset:`, presets.custom);
  }

  /**
   * Update the block's keyboard SVG preview
   */
  #updateBlockPreview() {
    const preview = this.querySelector("[data-block-preview]");
    if (!preview) return;

    // Update all keys
    Object.entries(this.#keyColors).forEach(([keyId, colorCode]) => {
      const key = preview.querySelector(`[data-key="${keyId}"]`);
      if (key) {
        const color = this.#findColorByCode(colorCode);
        if (color) {
          key.style.fill = color.hex;
        }
      }
    });

    // Update left top case
    const leftTopCases = preview.querySelectorAll('[data-case="left"]');
    const leftTopColor = this.#findColorByCode(this.#leftTopCaseColor);
    if (leftTopColor) {
      leftTopCases.forEach((el) => (el.style.fill = leftTopColor.hex));
    }

    // Update left bottom case
    const leftBottomCases = preview.querySelectorAll(
      '[data-case="left-bottom"]'
    );
    const leftBottomColor = this.#findColorByCode(this.#leftBottomCaseColor);
    if (leftBottomColor) {
      leftBottomCases.forEach((el) => (el.style.fill = leftBottomColor.hex));
    }

    // Update right top case
    const rightTopCases = preview.querySelectorAll('[data-case="right"]');
    const rightTopColor = this.#findColorByCode(this.#rightTopCaseColor);
    if (rightTopColor) {
      rightTopCases.forEach((el) => (el.style.fill = rightTopColor.hex));
    }

    // Update right bottom case
    const rightBottomCases = preview.querySelectorAll(
      '[data-case="right-bottom"]'
    );
    const rightBottomColor = this.#findColorByCode(this.#rightBottomCaseColor);
    if (rightBottomColor) {
      rightBottomCases.forEach((el) => (el.style.fill = rightBottomColor.hex));
    }

    // Update knobs if keyboard has them
    if (this.#keyboardConfig.hasKnobs && this.#knobColor) {
      const knobColor = this.#findColorByCode(this.#knobColor);
      if (knobColor) {
        this.#keyboardConfig.knobElements.forEach((side) => {
          const knob = preview.querySelector(`[data-knob="${side}"]`);
          if (knob) {
            knob.style.fill = knobColor.hex;
          }
        });
      }
    }
  }
}

/**
 * Custom event for apply action
 * Dispatched by the dialog when user clicks Apply
 */
export class KeyboardCustomizerApplyEvent extends CustomEvent {
  constructor(detail) {
    super(KeyboardCustomizerApplyEvent.eventName, {
      bubbles: true,
      detail,
    });
  }

  static eventName = "keyboard-customizer:apply";
}

if (!customElements.get("keyboard-customizer-component")) {
  console.log("Defining keyboard-customizer-component");
  customElements.define(
    "keyboard-customizer-component",
    KeyboardCustomizerComponent
  );
  console.log("keyboard-customizer-component defined");
} else {
  console.log("keyboard-customizer-component already defined");
}
